import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const helpers = createMultiStyleConfigHelpers(['button', 'icon'])

const getTextVariantStyling = (withPadding: boolean) =>
  defineStyle((props) => {
    const { colorScheme: theme } = props
    return {
      button: {
        paddingX: withPadding ? 2 : 0,
        paddingY: 2,
        color: `${theme}.aubergine.950`,
        fontSize: {
          base: '2xl',
          md: 'sm',
        },
        fontWeight: 300,
        fontFamily: 'Lausanne',
        position: 'relative',
        _hover: {
          _after: {
            content: '""',
            paddingX: withPadding ? 0 : 2, // No padding on the :after if the button already gets padding
            display: 'block',
            position: 'absolute',
            width: '100%',
            left: withPadding ? 0 : '-.5rem', // Compensate for the padding on the :after if applied
            borderRadius: 'lg',
            height: '80%',
            boxShadow:
              '0 0.063rem 0 0 rgba(var(--chakra-colors-aubergine-rgb), 0.5)',
          },
        },
      },
    }
  })

export const ButtonConfig = helpers.defineMultiStyleConfig({
  // The styles all Cards have in common
  baseStyle: defineStyle((props) => {
    const { colorScheme: theme } = props

    return {
      button: {
        borderRadius: 'lg',
        fontSize: 'md',
        fontWeight: '400',
        lineHeight: '100%',
        fontFamily: 'Cooper',
        padding: 5,
        display: 'flex',
        alignContent: 'center',
        width: 'fit-content',
      },
      icon: {
        color: `${theme}.aubergine`,
        svg: {
          width: '1.5rem',
          height: '1.5rem',
          fill: `${theme}.aubergine`,
        },
      },
    }
  }),
  variants: {
    primary: defineStyle((props) => {
      const { colorScheme: theme } = props
      return {
        button: {
          backgroundColor: `${theme}.aubergine`,
          color: `${theme}.white`,
        },
      }
    }),
    secondary: defineStyle((props) => {
      const { colorScheme: theme } = props
      return {
        button: {
          color: `${theme}.aubergine`,
          borderBottom: '0.125rem solid',
          borderColor: `${theme}.aubergine`,
        },
      }
    }),
    contactlinks: defineStyle((props) => {
      const { colorScheme: theme } = props
      return {
        button: {
          padding: 0,
          color: `${theme}.dark`,
          fontSize: '1rem',
          fontWeight: 300,
          lineHeight: '120%',
          fontFamily: 'Lausanne',
          alignItems: 'center',

          svg: {
            color: `${theme}.aubergine`,
            width: '1.5rem',
            height: '1.5rem',
            marginRight: '0.25rem',
          },
        },
      }
    }),
    text: getTextVariantStyling(true),
    textNoPadding: getTextVariantStyling(false),
  },
  sizes: {
    small: {
      button: {
        fontSize: 'md',
      },
      icon: {
        svg: {
          width: '1.5rem',
          height: '1.5rem',
        },
      },
    },
    large: {
      button: {
        fontSize: { base: '1.25rem', md: '1.5rem' },
      },
    },
  },
  // The default variant value
  defaultProps: {
    variant: 'primary',
    size: 'small',
  },
})
